import { Injectable, signal } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { Subject } from 'rxjs';

export type SideMenuAction = 'open' | 'close' | 'toggle';
/** The alternate menus `DynamicMenuComponent` can render. */
export type AltMenu = 'basket';

@Injectable({
  providedIn: 'root',
})
export class SideMenusService {
  public toggleMainMenuSubject = new Subject<SideMenuAction>();

  public toggleAltMenuSubject = new Subject<SideMenuAction>();
  public renderAltMenuSubject = new Subject<AltMenu>();

  public changeMainMenuModeSubject = new Subject<MatDrawerMode>();

  /**
   * The alternate menu (the basket): a standard side sheet beside the page on a wide screen, so the
   * page stays usable while it is open (design 3a); over the page on a narrower one.
   */
  readonly altMenuMode = signal<MatDrawerMode>('over');
  readonly altMenuOpened = signal(false);

  /** Shows the basket in the alternate menu. */
  openBasket(): void {
    this.renderAltMenuSubject.next('basket');
    this.toggleAltMenuSubject.next('open');
  }
}
